__turbopack_context__.v({
  "checkout": "Cart-module-scss-module__z-dLFW__checkout",
  "close": "Cart-module-scss-module__z-dLFW__close",
  "drawer": "Cart-module-scss-module__z-dLFW__drawer",
  "empty": "Cart-module-scss-module__z-dLFW__empty",
  "emptyHint": "Cart-module-scss-module__z-dLFW__emptyHint",
  "error": "Cart-module-scss-module__z-dLFW__error",
  "fadeIn": "Cart-module-scss-module__z-dLFW__fadeIn",
  "footer": "Cart-module-scss-module__z-dLFW__footer",
  "header": "Cart-module-scss-module__z-dLFW__header",
  "item": "Cart-module-scss-module__z-dLFW__item",
  "itemImage": "Cart-module-scss-module__z-dLFW__itemImage",
  "itemInfo": "Cart-module-scss-module__z-dLFW__itemInfo",
  "itemPrice": "Cart-module-scss-module__z-dLFW__itemPrice",
  "itemSize": "Cart-module-scss-module__z-dLFW__itemSize",
  "items": "Cart-module-scss-module__z-dLFW__items",
  "overlay": "Cart-module-scss-module__z-dLFW__overlay",
  "quantity": "Cart-module-scss-module__z-dLFW__quantity",
  "remove": "Cart-module-scss-module__z-dLFW__remove",
  "shippingBar": "Cart-module-scss-module__z-dLFW__shippingBar",
  "shippingFill": "Cart-module-scss-module__z-dLFW__shippingFill",
  "shippingProgress": "Cart-module-scss-module__z-dLFW__shippingProgress",
  "shippingText": "Cart-module-scss-module__z-dLFW__shippingText",
  "slideIn": "Cart-module-scss-module__z-dLFW__slideIn",
  "total": "Cart-module-scss-module__z-dLFW__total",
});
